import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text } from 'pcln-design-system'

export default function PriceRangeBox({ align, price }) {
  return (
    <Box width={1 / 2}>
      <Text bold fontSize={1} align={align}>
        {price}
      </Text>
    </Box>
  )
}

PriceRangeBox.propTypes = {
  align: PropTypes.string,
  price: PropTypes.string,
}
